import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import { useCurrentUser } from '@hero/hooks-shared';
import { AccountsListPage } from '@hero/web-components';

/**
 * Carrier-dashboard `/accounts` route — the replacement surface for
 * `/wallet`. Entity drawers mount once in `DashboardLayout`.
 */
export default function AccountsPage() {
  const { t } = useTranslation(['m-account']);
  const { setPageName } = usePageContext();
  const { orgId } = useCurrentUser();

  useEffect(() => {
    setPageName(t('m-account:page.title', { defaultValue: 'Accounts' }));
  }, [setPageName, t]);

  return <AccountsListPage viewerOrgId={orgId} />;
}
